/**
 * Source file reading and code snippet extraction for failure diagnostics.
 * Never throws — returns null on any error.
 */

import { readFileSync } from 'node:fs';

export function extractCodeSnippet(
  filePath: string,
  line: number,
  contextLines: number,
): string | null {
  try {
    const content = readFileSync(filePath, 'utf-8');
    const lines = content.split('\n');

    if (line < 1 || line > lines.length) return null;

    const startLine = Math.max(1, line - contextLines);
    const endLine = Math.min(lines.length, line + contextLines);

    const snippetLines: string[] = [];
    for (let i = startLine; i <= endLine; i++) {
      const marker = i === line ? '>' : ' ';
      const lineNum = String(i).padStart(String(endLine).length, ' ');
      snippetLines.push(`${marker} ${lineNum} | ${lines[i - 1]}`);
    }

    return snippetLines.join('\n');
  } catch {
    return null;
  }
}
